<template>
  <div class="menu-principal-container">
    <ModalAlerta :quantidade="quantidadeAlertaCadastroEmpresas" />
    <ModalEmail />
    <ModalFeedback />
    <div class="menu-principal-wrapper">
      <div class="menu-principal-link-container">
        <router-link
          class="menu-principal-link"
          :to="item.caminho"
          v-for="(item, index) in itemMenu"
          :key="index"
        >
          {{ item.nome }}
        </router-link>
        <a href="https://perfil.econeteditora.com.br/jornada-econet/96" target="_blank" class="menu-principal-link">Vídeo Explicativo</a>
      </div>
      <div class="menu-principal-nome">
        {{ getUser.nome_usuario.toUpperCase() }}
      </div>
      <div class="menu-principal-direita">
        <font-awesome-icon
          v-if="!!quantidadeAlertaCadastroEmpresas"
          v-b-tooltip.hover.top
          title="Clique para abrir o alerta"
          class="menu-principal-alerta-empresa"
          icon="exclamation-triangle"
          v-b-modal="'ModalAlertaEmpresaHeader'"
        />

        <HeaderInput
          :model="empresaSelecionada"
          :desabilita="blBigData"
          placeholder="Selecione uma empresa"
          noOptions="Sem opções de empresa"
          :options="listaEmpresas"
          @update:model="update => (empresaSelecionada = update)"
          @selected="update => setEmpresa(update)"
        />
        <BotaoDropdown
          class="menu-principal-botao-dropdown"
          icone="bell"
          direcao="esquerda"
          :desabilitado="getEmpresa.id ? false : true"
          :notificacao="opcoesNotificacao.length.toString()"
          semOpcoes="Sem notificações disponíveis."
          :opcoes="opcoesNotificacao"
          @dropdownClick="notificacoesClick"
          :loading="carregandoNotificacoes"
          @saiu="apagaNotificacoes"
        />
        <BotaoDropdown
          class="menu-principal-botao-dropdown"
          icone="user"
          direcao="esquerda"
          :opcoes="opcoesUsuario"
          @dropdownClick="dropdownClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HeaderInput from "@/components/HeaderInput/HeaderInput.vue";
import ModalAlerta from "@/components/v-header/ModalAlerta";
import BotaoDropdown from "@/components/BotaoDropdown/BotaoDropdown.vue";
import ModalEmail from "@/components/ModalEmail/ModalEmail.vue";
import ModalFeedback from "@/components/ModalFeedback/ModalFeedback.vue";

import Api from "@/services/api.js";
import router from "@/router.js";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "MenuPrincipal",
  components: {
    HeaderInput,
    ModalAlerta,
    BotaoDropdown,
    ModalEmail,
    ModalFeedback
  },
  data() {
    return {
      empresaSelecionada: null,
      exibelistaUsuario: false,
      carregandoNotificacoes: false,
      opcoesNotificacao: [],
      itemMenu: [
        { nome: "Pesquisar", caminho: "/" },
        { nome: "Empresas", caminho: "/empresas" },
        { nome: "Produtos", caminho: "/produtos" },
        { nome: "Monitoramento", caminho: "/monitoria-produto" }
      ],
      opcoesUsuario: [
        { id: 1, nome: "Configurar e-mails", icone: "cog" },
        { id: 2, nome: "Deixe a sua opinião", icone: "comment-alt" },
        { id: 3, nome: "Manual do usuário", icone: "book" },
        { id: 4, nome: "Resumo Técnico", icone: "passport" },
        { id: 5, nome: "Suporte Técnico", icone: "headset" },
        { id: 6, nome: "Termos de uso", icone: "file-signature" }
      ]
    };
  },
  created() {
    this.empresaSelecionada = this.getEmpresa.nome;
    this.obterNotificacoesEmpresa(this.getEmpresa.id);
  },
  watch: {
    getEmpresa() {
      this.obterNotificacoesEmpresa(this.getEmpresa.id);
    }
  },
  computed: {
    ...mapGetters("loading", {
      blBigData: "getBlBigData"
    }),
    ...mapGetters("empresa", ["getListEmpresa", "getEmpresa"]),
    ...mapGetters("login", ["getUser"]),
    ...mapGetters("auth", ["getUsuarioPro"]),
    listaEmpresas() {
      let lista = this.getListEmpresa;
      return lista && lista.length > 0 ? lista : [];
    },
    quantidadeAlertaCadastroEmpresas() {
      return this.getListEmpresa.filter(f => f.id_uf == "0").length;
    }
  },
  methods: {
    ...mapActions("empresa", ["setEmpresa"]),
    dropdownClick(item) {
      switch (item.id) {
        case 1:
          this.$root.$emit("bv::show::modal", "ModalEmail");
          break;

        case 2:
          this.$root.$emit("bv::show::modal", "ModalFeedback");
          break;

        case 3:
          window.open("http://grupoeconet.com.br/lp/rte-manual/", "_blank");
          break;

        case 4:
          // this.$bus.$emit("showModalLP", true);
          this.$root.$emit("bv::show::modal", "ModalResumoTecnico");
          break;

        case 5:
          window.open(
            "https://www.econeteditora.com.br/solucoes/index.php?acao=envio&form[destino]=10",
            "_blank"
          );
          break;

        case 6:
          this.$root.$emit("bv::show::modal", "ModalTermos");
          break;

        default:
          break;
      }
    },
    async obterNotificacoesEmpresa(idEmpresa) {
      if (this.getEmpresa.id) {
        this.carregandoNotificacoes = true;
        const response = await new Api().get(`Mudanca/obterNotificacao/${idEmpresa}`);
        this.opcoesNotificacao = response.dados;
        this.carregandoNotificacoes = false;
      }
    },
    notificacoesClick() {
      this.$router.push("/monitoria");
    },
    async apagaNotificacoes() {
      if (this.opcoesNotificacao.length > 0 && this.getEmpresa.id) {
        this.carregandoNotificacoes = true;
        if (!this.getUsuarioPro) {
          await new Api().post("Mudanca/salvarLeitura/" + this.getEmpresa.id, {
            idEmpresa: this.getEmpresa.id,
            arMudancas: this.opcoesNotificacao
          });
        }
        this.opcoesNotificacao = [];
        this.carregandoNotificacoes = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.menu-principal-container {
  background: var(--azul4);
  color: var(--branco);
  height: 40px;
  display: flex;
  justify-content: center;
  width: 100%;
}
.menu-principal-wrapper {
  width: 100%;
  padding: 0 15px;
  max-width: 1155px;
  display: flex;
  justify-content: space-between;
}
.menu-principal-link-container {
  display: flex;
}
.menu-principal-link {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  font-family: "Roboto Condensed";
  font-size: 14px;
  color: var(--branco);
  transition: background 0.2s ease-in-out;
  border-right: 1px solid var(--cinza2);
  &:hover {
    background: var(--azul3);
  }
  &:first-child {
    // border-right: none;
    border-left: 1px solid var(--cinza2);
  }
}
.menu-principal-direita {
  display: flex;
}
.menu-principal-usuario {
  background: var(--azul5);
  font-size: 18px;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 0 5px 10px;
  border-radius: 50%;
  cursor: pointer;
}
.menu-principal-nome {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  font-family: "Roboto Condensed";
  font-size: 10px;
}
.menu-principal-alerta-empresa {
  height: 40px;
  cursor: pointer;
  color: orange;
  margin-right: 5px;
}
.menu-principal-botao-dropdown {
  margin: 5px 0 5px 10px;
}
</style>
